import styled from "styled-components";
import ReactDOM from "react-dom";

export default function WarningModal({ action, handleOpen }) {
  return ReactDOM.createPortal(
    <WarningModalContainer onClick={handleOpen}>
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <h2>Warning!</h2>
        <p>This will remove all drawn features from the map. This action cannot be undone. Continue?</p>
        <div>
          <button onClick={handleOpen}>Cancel</button>
          <button onClick={() => action()}>Confirm</button>
        </div>
      </ModalContent>
    </WarningModalContainer>,
    document.body
  );
}

const WarningModalContainer = styled.div`
  position: absolute;
  inset: 0;
  z-index: 1000;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ModalContent = styled.div`
  display: grid;
  justify-items: center;
  background-color: white;
  width: 300px;
  border-radius: 8px;
  padding: 20px;

  h2 {
    margin: 0;
  }

  p {
    text-align: center;
    font-weight: 500;
    margin: 5px 0 15px 0;
  }

  div {
    display: flex;
    gap: 10px;

    button {
      all: unset;
      padding: 5px 10px;
      border-radius: 5px;
      cursor: pointer;
      color: white;
      font-weight: bold;
    }

    button:first-child {
      background-color: gray;
    }
    button:last-child {
      background-color: #ee2720;
    }
  }
`;
